
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[shortId]",
      function () {
        return require("private-next-pages/[shortId].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[shortId]"])
      });
    }
  